import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import OperationalStatusService from "@services/OperationalStatusService";

const ShowOperationalStatus = ({ operationalStatus }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [operationalStatusData, setOperationalStatusData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      OperationalStatusService.find(operationalStatus.id).then((response) => {
        setOperationalStatusData(response.data.data);
      });
  }, [operationalStatus.id, showModal]);

  return (
    <PermissionHandler permission={"view_operational_statuses"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails label={t("name")} value={operationalStatusData?.name} />
          <RowDetails
            label={t("nameEng")}
            value={operationalStatusData?.name_eng}
          />
          <RowDetails
            label={t("description")}
            value={operationalStatusData?.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowOperationalStatus;
